<script lang="ts" setup>
import { NButton } from 'naive-ui'

const props = withDefaults(
  defineProps<{
    iconPlacement?: 'left' | 'right'
  }>(),
  {
    iconPlacement: 'right',
  },
)
</script>

<template>
  <NButton :bordered="true" class="c-button" :icon-placement="props.iconPlacement">
    <template #icon>
      <slot name="icon" />
    </template>

    <slot />
  </NButton>
</template>

<style lang="scss" scoped>
.c-button {
  text-transform: uppercase;
  letter-spacing: 1.25px;
}
</style>
